define('drops/pattern/pattern',[
    'jquery',
    'lq/drop'
], function ($, Drop) {
	'use strict';

    var defaults = {
        data: {
            selectedPattern: 'weave'
        }
    };
    
    function Pattern(options) {
        Drop.call(this, $('<div/>'), defaults, options);
        this.$element.addClass(this.data.selectedPattern);
	};

    Drop.extend(Pattern, Drop);

    Pattern.typeName = 'Pattern';

    Pattern.prototype.preRender = function () {
        this.applyPosition();
    };

    return Pattern;
});
